var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"label":_vm.label,"error-messages":_vm.errorMessages,"v-validate":_vm.validate,"data-vv-name":_vm.dataVvName,"required":_vm.required},on:{"change":_vm.updateValue},model:{value:(_vm.formattedValue),callback:function ($$v) {_vm.formattedValue=$$v},expression:"formattedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }